export default {
    baseStyle: {
        wrapper: {
            width: '100%'
        },
        selectOptionDay: {
            width: '30%'
        },
        selectOptionMonth: {
            width: '40%'
        },
        selectOptionYear: {
            width: '30%'
        },
        select: {
            borderRadius: '0px',
            _focus: {
                borderstyle: 'solid',
                borderColor: 'black',
                borderRadius: '4px',
                borderWidth: '2px',
                paddingRight: '1rem !important'
            },
            _invalid: {
                color: 'red.550',
                backgroundColor: 'red.750',
                border: '1px solid',
                borderColor: 'red.550',
                borderRadius: 0,
                _focus: {
                    borderstyle: 'solid',
                    borderColor: 'black',
                    borderRadius: '4px',
                    borderWidth: '2px'
                }
            }
        },
        dobError: {
            color: 'red.550',
            marginTop: '0px',
            fontSize: '12px',
            width: 'inherit',
            position: 'absolute',
            fontWeight: '400',
            top: '100%',
            lineHeight: 'normal'
        }
    }
}
